import { Outlet } from 'react-router-dom'
import { useState } from 'react'

import { ThemeModeProvider } from '../partials'
import { PageDataProvider } from './core'

const AppWebviewLayout = () => {
  const [pageTitle, setPageTitle] = useState("");

  return (
    <PageDataProvider>
      <ThemeModeProvider>
      <meta name="viewport" content="width=device-width, user-scalable=no"/>
        <div className='webview-wrapper'>
          {pageTitle &&
            <div className='webview-header'>{pageTitle}</div>}
          <div className='webview-pg-content-wrapper'>
            <Outlet context={{ setPageTitle }} />
          </div>
        </div>
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export { AppWebviewLayout }
